import {
  SnoozeTransactionUntilDocument,
  UnsnoozeTransactionDocument,
} from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export const useSnoozeTransaction = () => {
  const { company } = useCurrentSession()
  const [snoozeTransaction, { loading, error }] = useMutation(SnoozeTransactionUntilDocument, {
    extractorFn: (d) => d.bankingMutations.snoozeBankingTransaction,
  })
  const [unsnoozeTransaction, { loading: loadingUnsnooze, error: errorUnsnooze }] = useMutation(
    UnsnoozeTransactionDocument,
    {
      extractorFn: (d) => d.bankingMutations.unsnoozeBankingTransaction,
    }
  )

  const snooze = useUnsafeCallback(
    async (transactionId: string, until: Date) => {
      const response = await snoozeTransaction({
        variables: {
          companyId: company.id,
          transactionId,
          snoozedUntil: until.toISOString(),
        },
      })
      const result = handleResult(response, () => undefined)
      if (result.success) {
        return result.data.transaction
      }
    },
    [company, snoozeTransaction]
  )

  const unsnooze = useUnsafeCallback(
    async (transactionId: string) => {
      const response = await unsnoozeTransaction({
        variables: {
          companyId: company.id,
          transactionId,
        },
      })
      const result = handleResult(response, () => undefined)
      if (result.success) {
        return result.data.transaction
      }
    },
    [company, unsnoozeTransaction]
  )

  return {
    loading: loading || loadingUnsnooze,
    error: error || errorUnsnooze,
    snooze,
    unsnooze,
  }
}
